import { useAppDispatch } from "@/store/storeHooks";
import api from "@/shared/api/base/apiClient";
import {
  setButtonDisable,
  setOpenDrawer,
} from "@/widgets/elements/formDrawer/formdrawer.slice";
import { reRenderTable } from "@/widgets/elements/table/reducer/table.slice";
import {
  useMutation,
  type UseMutationOptions
} from "@tanstack/react-query";
import { type AxiosResponse, type Method } from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

export const useApiMutation = <
  Variables = any,
  Response = {},
  Error extends { message?: string } = {}
>(
  url: string,
  method: Method,
  options: UseMutationOptions<AxiosResponse<Response>, Error, Variables> = {},
  withoutNotification?: boolean
) => {
  const dis = useAppDispatch();
  const { t } = useTranslation();

  return useMutation<AxiosResponse<Response>, Error, Variables>({
    mutationFn: async (data: Variables) => {
      const response = await api({ url, method, data });
      return response;
    },
    onError(error: Error) {
      toast.error(
        error?.message || "Server error"
      );
    },
    onMutate() {
      dis(setButtonDisable(true));
    },
    onSuccess() {
      if (!withoutNotification) {
        toast.success(t("TOAST_MESSAGES.SUCCESS"));
      }
      dis(setOpenDrawer(false));
      dis(reRenderTable(true));
    },
    onSettled() {
      dis(setButtonDisable(false));
    },
    ...options,
  });
};